import { AdminPagesStateModel } from "../../admin.state";
import { SystemConfig } from "../interfaces/system-config.interface";

export class SystemConfigsStateModel extends AdminPagesStateModel {
  items: SystemConfig[];
}